export default class AuthService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getToken() {
    return localStorage.getItem(this.serviceConfig.storageTokenKeyName);
  }

  getRefreshToken() {
    return localStorage.getItem(this.serviceConfig.storageRefreshTokenKeyName);
  }

  setToken(value) {
    localStorage.setItem(this.serviceConfig.storageTokenKeyName, value);
  }

  setRefreshToken(value) {
    localStorage.setItem(this.serviceConfig.storageRefreshTokenKeyName, value);
  }

  login(...args) {
    return this.axiosIns.post(this.serviceConfig.loginEndpoint, ...args);
  }

  forgotPassword(...args) {
    return this.axiosIns.post(this.serviceConfig.forgotPasswordEndpoint, ...args);
  }

  resetPassword(...args) {
    return this.axiosIns.post(this.serviceConfig.resetPasswordEndpoint, ...args);
  }

  register(...args) {
    return this.axiosIns.post(this.serviceConfig.registerEndpoint, ...args);
  }

  updatePassword(...args) {
    return this.axiosIns.post(this.serviceConfig.updatePassword, ...args);
  }

  me() {
    return this.axiosIns.get(this.serviceConfig.meEndpoint);
  }

  refreshToken() {
    return this.axiosIns.post(this.serviceConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken()
    });
  }

  verifyUser(token) {
    return this.axiosIns.get(`${this.serviceConfig.users}/verify-user/${token}`);
  }
}
